import React, { useEffect } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import {
  FormButtons,
  ICONS,
  renderers,
  Slider,
  validations,
} from '../../components'
import { useSelector } from 'react-redux'
import { getLists } from '../../state/lists'
import Embed from 'react-embed'

const maxLength200 = validations.maxLength(200)
const minLength10 = validations.minLength(10)
function renderManagerSuggestion(user) {
  return (
    <ReactBootstrap.Col className={"ps-2"}>
      <h5>{user.first_name + ' ' + user.last_name}</h5>
      <h6>{user.email}</h6>
    </ReactBootstrap.Col>
  )
}
let OrganizationForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  manager_name,
  dispatch,
}) => {
  const { country, states } = useSelector((state) => state.lists)
  const { geoLocation } = useSelector((state) => state.application)
  const setLatLong = () => {
    dispatch(change('organization-form', 'latitude', geoLocation.latitude))
    dispatch(change('organization-form', 'longitude', geoLocation.longitude))
  }
  useEffect(() => {
    !country && dispatch(getLists('COUNTRY'))
    !states && dispatch(getLists('STATES'))
  }, [country, states, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            name="name"
            label="Name"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Code Name"
            name="code"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Token Machine Code"
            name="token_machine_location_code"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="GSX Ship To"
            name="gsx_ship_to"
            component={renderers.renderField}
            validate={[validations.required, minLength10]}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Timings"
            name="timings"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Contact Number"
            name="contact_number"
            validate={[validations.required, minLength10, maxLength200]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Email"
            name="email"
            validate={[validations.required, validations.email]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Address"
            name="address"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="PIN "
            name="pin_code"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            name="city"
            label="City"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Organization Latitude "
            name="latitude"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            name="longitude"
            label="Organization Longitude"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end p-0 m-0" xs={12}>
          <Slider
            title={<span>{ICONS.VIEW}Find coordinate of remote locations</span>}
            header={
              <span>{ICONS.VIEW}Find coordinate of remote locations </span>
            }
            buttonType="dropdown"
          >
            <div>
              <strong>
                {' '}
                Follow this video to generate the values manually{' '}
              </strong>{' '}
              <br />
              <Embed url="https://youtu.be/2yOX7soSPeQ" />
            </div>
          </Slider>
          <ReactBootstrap.Button
            onClick={() => setLatLong()}
            variant="link"
            className="mr-3 p-0 m-0 text-dark"
          >
            Use My Current Location
          </ReactBootstrap.Button>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="state"
            label="State"
          >
            {states &&
              states.map((state) => {
                return (
                  <option key={state.url} value={state.value}>
                    {state.value}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="country"
            label="Country"
          >
            {country &&
              country.map((country) => {
                return (
                  <option key={country.url} value={country.value}>
                    {country.value}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
         <ReactBootstrap.Col xs={12} md={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="org_type"
            label="Organization Type"
          >
            {["ASP","DROP OFF"].map((value) => {
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="User"
            name="manager"
            component={renderers.renderHiddenField}
            type="text"
          />
          <Field
            label="Manager "
            name="manager_suggestions"
            renderSuggestion={renderManagerSuggestion}
            endpoint="users"
            actualFieldName="manager"
            initialValue={manager_name}
            component={renderers.EaseOnAutoSuggest}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            name="gmail_app_password"
            label="Gmail Password"
            validate={[validations.required]}
            component={renderers.renderField}
            type="password"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end p-0 m-0" xs={12}>
          <Slider
            title={
              <span>
                {ICONS.VIEW}Follow this video to generate the value for app
                password
              </span>
            }
            header={
              <span>
                {ICONS.VIEW}Follow this video to generate the value for app
                password
              </span>
            }
            buttonType="dropdown"
          >
            <div>
              <h3>
                {' '}
                <strong>
                  {' '}
                  Follow this video to generate the value for app password{' '}
                </strong>{' '}
                <br />
              </h3>
              <Embed url="https://youtu.be/hXiPshHn9Pw" />
            </div>

            <div>
              <br /> <br /> <br /> <br />
              <h3>
                {' '}
                <strong>
                  {' '}
                  Follow this video to allow CRM to Send Emails on organizations
                  behalf{' '}
                </strong>{' '}
                <br />
              </h3>
              <Embed url="https://www.youtube.com/watch?v=Ee7PDsbfOUI" />
            </div>
          </Slider>
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs={12} md={12}>
          <Field
            name="rdo_location_id"
            label="RDO Location ID"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col md={12} xs={12} lg={12}>
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
OrganizationForm = reduxForm({
  form: 'organization-form',
  initialValues: {
    country: 'India',
  },
})(OrganizationForm)

export default OrganizationForm
